<template>
    <div style="display: flex; flex-direction: column; gap: 24px; width: 100%; margin-top: 16px;">
        <div class="section-row">
            <div class="section-left">
                <div class="section-inner">
                    <div class="large-checkbox">
                        <el-checkbox label="Our Goals" v-model="tab_form.sections.our_goals.is_active"></el-checkbox>
                    </div>
                    <div style="padding-left: 24px; width: 100%" v-if="tab_form.sections.our_goals.is_active">
                        <div style="margin: 1rem 0 2.5rem 0">
                            <p style="font-weight: bold">Logo</p>
                            <el-upload
                                :action="uploadUrl"
                                list-type="picture-card"
                                :on-preview="handlePictureCardPreview"
                                :on-remove="x => handleLogoRemove(x)"
                                :on-success="x => logoUploaded(x)"
                                :file-list="logoFileList"
                                :class="{ hideUpload: this.logoFileList.length > 0 }"
                            >
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </div>

                        <div style="margin: 2.5rem 0">
                            <p style="font-weight: bold">Sign by</p>
                            <el-date-picker v-model="tab_form.please_sign_by" value-format="yyyy-MM-dd" type="date" :clearable="false"></el-date-picker>
                        </div>
                        <froala tag="textarea" :config="froalaConfig" v-model="tab_form.sections.our_goals.content" />
                    </div>
                </div>
            </div>

            <div class="section-right">
                <proposal-preview-section 
                    :form_data="form_data"
                    section="our_goals"
                />
            </div>
        </div>

        <div class="section-row">
            <div class="section-left">
                <div class="large-checkbox">
                    <el-checkbox label="Unlimited Job Board Posts" v-model="tab_form.sections.job_board.is_active"></el-checkbox>
                </div>
                <div style="padding-left: 24px; width: 100%" v-if="tab_form.sections.job_board.is_active">
                    <froala tag="textarea" :config="froalaConfig" v-model="tab_form.sections.job_board.content" />
                </div>
            </div>

            <div class="section-right">
                <proposal-preview-section 
                    :form_data="form_data"
                    section="job_board"
                />
            </div>
        </div>

        <div class="section-row">
            <div class="section-left">
                <div class="large-checkbox">
                    <el-checkbox label="Job Posts in Every City" v-model="tab_form.sections.hiring_area.is_active"></el-checkbox>
                </div>
            </div>

            <div class="section-right">
                <proposal-preview-section 
                    :form_data="form_data"
                    section="hiring_area"
                />
            </div>
        </div>

        <div class="section-row">
            <div class="section-left">
                <div class="large-checkbox">
                    <el-checkbox label="Hammer GPS &amp; Job Adviser" v-model="tab_form.sections.hammer_and_job_adviser.is_active"></el-checkbox>
                </div>
            </div>

            <div class="section-right">
                <proposal-preview-section 
                    :form_data="form_data"
                    section="hammer_and_job_adviser"
                />
            </div>
        </div>

        <div class="section-row">
            <div class="section-left">
                <div class="large-checkbox">
                    <el-checkbox label="Multi-Carrier Leads" v-model="tab_form.sections.mc_leads.is_active"></el-checkbox>
                </div>
                <div style="padding-left: 24px; width: 100%" v-if="tab_form.sections.mc_leads.is_active">
                    <froala tag="textarea" :config="froalaConfig" v-model="tab_form.sections.mc_leads.content" />
                </div>
            </div>

            <div class="section-right">
                <proposal-preview-section 
                    :form_data="form_data"
                    section="mc_leads"
                />
            </div>
        </div>

        <div class="section-row">
            <div class="section-left">
                <div class="section-inner">
                    <div class="large-checkbox">
                        <el-checkbox label="Video Advertising" v-model="tab_form.sections.video_advertising.is_active"></el-checkbox>
                    </div>
                    <div style="padding-left: 24px; width: 100%" v-if="tab_form.sections.video_advertising.is_active">
                        <froala tag="textarea" :config="froalaConfig" v-model="tab_form.sections.video_advertising.content_hammer" />
                    </div>
                    <div style="padding-left: 24px; width: 100%" v-if="tab_form.sections.video_advertising.is_active">
                        <froala tag="textarea" :config="froalaConfig" v-model="tab_form.sections.video_advertising.content_truckersreport" />
                    </div>
                </div>
            </div>

            <div class="section-right">
                <proposal-preview-section 
                    :form_data="form_data"
                    section="video_advertising"
                />
            </div>
        </div>

        <div class="section-row">
            <div class="section-left">
                <div class="section-inner">
                    <div class="large-checkbox">
                        <el-checkbox label="Brand &amp; Reputation" v-model="tab_form.sections.brand_and_reputation.is_active"></el-checkbox>
                    </div>
                    <div style="padding-left: 24px; width: 100%" v-if="tab_form.sections.brand_and_reputation.is_active">
                        <froala tag="textarea" :config="froalaConfig" v-model="tab_form.sections.brand_and_reputation.content" />
                    </div>
                </div>
            </div>

            <div class="section-right">
                <proposal-preview-section 
                    :form_data="form_data"
                    section="brand_and_reputation"
                />
            </div>
        </div>

        <div class="section-row">
            <div class="section-left">
                <div class="section-inner">
                    <div class="large-checkbox">
                        <el-checkbox label="TruckersReport New Hire Guarantee" v-model="tab_form.sections.new_hire_guarantee.is_active"></el-checkbox>
                    </div>
                    <div style="padding-left: 24px; width: 100%" v-if="tab_form.sections.new_hire_guarantee.is_active">
                        <froala tag="textarea" :config="froalaConfig" v-model="tab_form.sections.new_hire_guarantee.content" />
                    </div>
                </div>
            </div>

            <div class="section-right">
                <proposal-preview-section 
                    :form_data="form_data"
                    section="new_hire_guarantee"
                />
            </div>
        </div>

        <div class="section-row">
            <div class="section-left">
                <div class="large-checkbox">
                    <el-checkbox label="Pricing Options" v-model="tab_form.sections.pricing_options.is_active"></el-checkbox>
                </div>
            </div>

            <div class="section-right">
                <proposal-preview-section 
                    v-if="tab_form.sections.pricing_options.is_active"
                    :form_data="form_data"
                    section="pricing_options"
                />
            </div>
        </div>

        <div class="section-row">
            <div class="section-left">
                <div class="section-inner">
                    <div class="large-checkbox">
                        <el-checkbox label="Agreement" v-model="tab_form.sections.agreement.is_active"></el-checkbox>
                    </div>
                    <div style="padding-left: 24px; width: 100%" v-if="tab_form.sections.agreement.is_active">
                        <froala tag="textarea" :config="froalaConfigAgreement" v-model="tab_form.sections.agreement.content" />
                        <div style="margin: 8px 0">
                            Available variables:
                            <code>{client}</code>, <code>{plan_name}</code>, <code>{price}</code>, <code>{term_length}</code>, <code>{term_length_months}</code>, <code>{first_paid_month}</code>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section-right">
                <proposal-preview-section 
                    v-if="tab_form.sections.agreement.is_active"
                    :form_data="form_data"
                    section="agreement"
                />
            </div>
        </div>

    </div>
</template>

<script>
import ProposalIframe from './../preview/proposal-iframe.vue';
import ProposalPreviewSection from './../preview/proposal-preview-section.vue';
import ProposalPreviewPricingOption from './../preview/proposal-preview-pricing-option.vue';

export default {
    components: {
        ProposalIframe,
        ProposalPreviewSection,
        ProposalPreviewPricingOption,
    },
    props: {
        proposal: {
            type: Object,
            required: true
        },
        tab_form: {
            type: Object,
            required: true
        },
        form_data: {
            type: Object,
            required: true
        },
    },
    data() {
        const froalaConfig = {
            key: 'CA4D4A2D3E1D2tA6B4B3A1C7D1G2E1E4A3oa2Pe2HTPYh1RNc2E1KDc1==',
            charCounterCount: false,
            height: 200,
            placeholderText: '',
            enter: $.FroalaEditor.ENTER_P,
            toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', '|',  'html'],
            htmlAllowedTags: ['strong', 'b', 'i', 'em', 'u', 's', 'br', 'p'],

            // always clean on Word paste (not giving a choice)
            wordPasteModal: false,
            wordPasteKeepFormatting: false,
        };

        return {
            froalaConfig: froalaConfig,
            froalaConfigAgreement: _.merge(_.cloneDeep(froalaConfig), {
                height: 450
            }),
            uploadUrl: url("/admin/glp/upload-image"),
        };
    },
    computed: {
        logoFileList: function () {
            if(! this.tab_form.logo_url) {
                return [];
            }

            return [{
                url: this.tab_form.logo_url
            }];
        },

    },
    methods: {
        handleLogoRemove() {
            this.tab_form.logo_url = null;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        logoUploaded(response) {
            this.tab_form.logo_url = response;
        },
    }
}
</script>

<style scoped>
    div.section-row {
        display: flex;
        justify-content: space-between
    }
    div.section-left {
        display: flex;
        width: 50%;
        flex-direction: column;
        gap: 24px;
    }
    div.section-right {
        width: 45%;
        margin-top: -40px; /* hack to compensate for h2 margin-top */
    }

    div.section-inner {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%
    }
</style>
